import axios from "axios";

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_URL });

// Attach token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// A 401 from a sign-in attempt is the answer to a credential check, not an expired session.
// Redirecting on those would reload the page and throw away the inline error message.
const CREDENTIAL_ENDPOINTS = [
  "/auth/login", "/auth/signup", "/auth/accept-invite", "/auth/reset-password",
  "/admin/login", "/platform/login", "/platform/invite/accept",
];

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const url = err.config?.url || "";
      const isCredentialCheck = CREDENTIAL_ENDPOINTS.some((p) => url.endsWith(p));
      if (!isCredentialCheck) {
        localStorage.removeItem("lf_token");
        localStorage.removeItem("lf_user");
        localStorage.removeItem("lf_clinic");
        window.location.href = "/app/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
